import template from "./two-factor-success.html";
import controller from "./two-factor-success.controller";
import "./two-factor-success.scss";

const TwoFactorSuccessComponent = {
    template,
    controller,
    controllerAs: "success"
};

export default TwoFactorSuccessComponent; 


// WEBPACK FOOTER //
// ./sources/components/auth/two-factor/two-factor-success.component.js